import {
  Create,
  required,
  SaveButton,
  SimpleForm,
  TextInput,
  TopToolbar,
  useNotify,
} from "react-admin";

import { MODULE_NAMES } from "@/constants/modules";

const CreateActions = () => (
  <TopToolbar sx={{ justifyContent: "flex-start", p: "0 0 16px 16px" }}>
    <SaveButton label="Issue premium" />
  </TopToolbar>
);

export const PremiumIssuancePage = () => {
  const notify = useNotify();
  const onSuccess = () => {
    notify("Premium has been issued successfully", {
      type: "success",
    });
  };

  return (
    <Create
      resource={MODULE_NAMES.PREMIUM_ISSUANCE}
      mutationOptions={{
        onSuccess,
      }}
    >
      <SimpleForm toolbar={<CreateActions />}>
        <TextInput source="deviceId" validate={required()} label="Device ID" />
      </SimpleForm>
    </Create>
  );
};
